import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { getErrorMessage } from '../../../libs/ui-components/components/custom-post-error.handler';
import { Button, Dialog } from '@lib/ui-components';
import { DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

interface DeleteCollectionRequestProps {
  collectionRequestId: string;
  afterSubmit?: () => void;
  disabled?: boolean;
}

export const DeleteCollectionRequestButton = (props: DeleteCollectionRequestProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    setError(null);
    setBusy(true);
    try {
      await axios({
        method: 'post',
        url: '/api/usecase/collection-request/delete-single-collection-request',
        data: { collectionRequestId: props.collectionRequestId },
        responseType: 'json',
      });
      setOpen(false);
      props.afterSubmit?.();
    } catch (e) {
      const translations = i18n.getDataByLanguage(i18n.language);
      const data = (e as { response?: { data?: { code?: string; context?: string } } })?.response?.data;
      setError(getErrorMessage({ code: data?.code, context: data?.context }, translations) || t('unexpectedError'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button label={t('deleteOrder')} variant='outlined' color='secondary' isDisabled={props.disabled || busy} onClick={() => setOpen(true)} />
      <Dialog open={open} maxWidth='sm' fullWidth={true}>
        <DialogTitle sx={{ margin: 'auto' }}>
          {t('deleteOrder')}
          <IconButton
            aria-label='close'
            onClick={() => setOpen(false)}
            data-test-id={'dialog-close-btn'}
            sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {t('deleteOrderConfirmation')}
          {error && <div style={{ color: 'red', marginTop: '0.5rem' }}>{error}</div>}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', paddingBottom: '2rem', '& button': { padding: '0.6rem 2.3rem', fontSize: '0.9rem' } }}>
          <Button label={t('cancel')} color='primary' variant='text' isDisabled={busy} onClick={() => setOpen(false)} />
          <Button label={t('confirm')} color='secondary' variant='contained' isDisabled={busy} onClick={confirm} />
        </DialogActions>
      </Dialog>
    </>
  );
};
